<template>
  <div class="layout">
    <div class="menu">
      <Menu topIndex="5"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="labelManage" leftIndex="1"></LeftSideBar>
    </div>

    <div id="sortContent">
      <div class="left-tree">
        <div>
          <el-input
            class="subject-search-input"
            placeholder="请输入名称"
          ></el-input>
          <el-button type="text" size="small" icon="el-icon-search">
          </el-button>
        </div>
        <el-tree
          show-checkbox
          node-key="id"
          default-expand-all
          :check-on-click-node="true"
          :check-strictly="true"
        >
        </el-tree>
      </div>
      <div class="rightBox">
        <!-- 上方按钮 -->
        <div class="button-box">
          <el-button
            type="text"
            icon="el-icon-plus"
            size="small"
            @click="creatTag()"
            >新建标引库</el-button
          >
          <el-button
            type="text"
            icon="el-icon-edit"
            size="small"
            @click="createSort()"
            >编辑标引库</el-button
          >
          <el-button type="text" icon="el-icon-delete" size="small"
            >删除标引库</el-button
          >
          <el-button
            type="text"
            icon="el-icon-circle-plus-outline"
            size="small"
            @click="deletePre()"
            >添加标引标签</el-button
          >

          <el-button
            type="text"
            icon="el-icon-circle-close"
            size="small"
            @click="sourceCompare()"
            >删除标引标签</el-button
          >
        </div>
        <!-- 上方按钮end -->
        <div class="contentBox">
          <div class="tip-text">请选择资源库</div>
          <el-tabs value="first">
            <el-tab-pane label="标签列表" name="first">
              <el-table
                :data="tableData"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  min-width="80"
                  label="标签名称"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  min-width="80"
                  label="标签"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  min-width="80"
                  label="标签说明"
                  align="center"
                ></el-table-column
              ></el-table>
            </el-tab-pane>
            <el-tab-pane label="使用情况" name="second">
              <el-table
                :data="tableData"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>

          <!-- 资源出库弹窗 -->
          <el-dialog
            title="资源出库"
            :visible.sync="creatTagDialog"
            width="600px"
          >
            <el-form>
              <el-form-item label="名称" label-width="80px">
                <el-input type="text" placeholder="请填写标引库名称"></el-input>
              </el-form-item>
              <el-form-item label="资源分类" label-width="80px">
                <el-select placeholder="选择资源分类">
                  <el-option>1</el-option>
                  <el-option>1</el-option>
                  <el-option>1</el-option>
                  <el-option>1</el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary">确 定</el-button>
              <el-button @click="creatTagDialog = false">取 消</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
// import $ from "jquery";
export default {
  data: function () {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
      // 弹窗组
      creatTagDialog: false,
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {},
  methods: {
    creatTag() {
      this.creatTagDialog = true;
    },
  },
};
</script>

<style>
#sortContent {
  clear: both;
  margin-top: -8px;
  margin-left: 170px;
}
.rightBox {
  float: right;
  width: calc(100% - 250px);
}
.information {
  width: 100%;
}

.el-dialog .el-form {
  padding: 10px 50px;
}

.reorderPreDialog {
  text-align: center;
}

.reorderPreDialog .el-input {
  display: inline;
}
.reorderPreDialog input {
  width: 100px;
}
.reorderPreDialog .red {
  color: red;
}
.sortEditForm label {
  text-align: left;
}

.sortEditForm {
  padding: 10px 50px;
}

.sortEditForm .el-form-item {
  display: block;
  margin: 5px 0;
}

.mainBox {
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
}
.mainBox::after,
.mainBox .leftBoxDialog {
  content: "";
  display: inline-block;
  clear: both;
}
.mainBox .leftBoxDialog {
  width: 30%;
  float: left;
  border-right: 1px solid #dcdfe6;
}
.mainBox .leftBoxDialog input {
  width: 100%;
  height: 30px;
  font-size: 14px;
}
.mainBox .leftBoxDialog .el-input,
.mainBox .leftBoxDialog .el-select {
  float: left;
}
.mainBox .leftBoxDialog .leftUp {
  border-bottom: 1px solid #50b58d;
  padding: 10px 0 10px 10px;
}

.mainBox .leftBoxDialog .el-input__icon {
  line-height: 30px;
}
.mainBox .rightBoxDialog {
  width: 69%;
  float: left;
}

.mainBox .rightBoxDialog .dialogBtnBox {
  border-bottom: 1px solid #50b58d;
  padding: 8px 0 8px 10px;
}

.mainBox .rightBoxDialog .el-form {
  padding: 10px 20px;
}

.mainBox .rightBoxDialog .el-form .el-textarea textarea {
  height: 300px;
}

#searchBox {
  padding-bottom: 22px;
}

#searchBox .el-select {
  width: 202px;
}

#searchBox .el-form-item {
  margin-bottom: 0;
}

#searchBox .el-form button.el-button {
  margin-left: 20px !important;
}

#searchBox .el-date-editor .el-range__icon {
  line-height: 25px;
}

#searchBox.el-date-editor .el-range-separator {
  line-height: 23px;
}
</style>